import { render } from "./HistoricIncidencesComponent.vue?vue&type=template&id=a52f5562"
import script from "./HistoricIncidencesComponent.vue?vue&type=script&lang=js"
export * from "./HistoricIncidencesComponent.vue?vue&type=script&lang=js"

import "./HistoricIncidencesComponent.vue?vue&type=style&index=0&id=a52f5562&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__